<script>
import appConfig from '@/app.config'
import Layout from '@/router/layouts/main'
import GmapCustomMarker from 'vue2-gmap-custom-marker'
import { Helper } from '@/mixin/helper'
import i18n from '@/i18n'

/**
 * Starter component
 */
export default {
  name: 'ModalCall',
  page: {
    title: 'Notifikasi',
    meta: [{ name: 'description', content: appConfig.description }],
  },
  components: {
    Layout,
    'gmap-custom-marker': GmapCustomMarker,
  },
  mixins: [Helper],
  data() {
    return {
      showHideDetailNotif: false,
      phaseOneShow: false,
      popoverShow: false,
      detail: JSON.parse(localStorage.getItem('drivers-detail-map')),
    }
  },
  computed: {
    language() {
      return i18n.locale
    },
  },
  methods: {
    onClose() {
      this.popoverShow = false
    },
  },
}
</script>
<template>
  <Layout>
    <div class="mc-liveview__map mc-liveview__map--notification">
      <div class="mc-liveview-ico">
        <span>
          <span class="mc-liveview-legend">
            <i class="mc-fa icon-outline_info" id="legend"></i>

            <b-popover
              target="legend"
              triggers="click"
              :show.sync="popoverShow"
              placement="rightmiddle"
              container="my-container"
              ref="popover"
            >
              <template #title>
                {{ $t('global.object.remarks') }}
                <i
                  @click="onClose"
                  class="mc-popover-close mc-fa icon-outline_close"
                  aria-hidden="true"
                ></i>
              </template>

              <div class="mc-popover-content mc-popover-content--legend">
                <ul>
                  <li>
                    <p>{{ $t('global.object.fleetStatus') }}</p>
                    <div>
                      <label
                        ><img
                          :src="
                            require(`@/assets/images/vehicles/${detail.vehicle.vehicleType.icon}/${detail.vehicle.vehicleType.icon}-green.png`)
                          "
                          :alt="`mceasy-liveview-${detail.vehicle.vehicleType.icon}-icon`"
                        /><span>{{ $t('global.filter.running') }}</span></label
                      >
                      <label
                        ><img
                          :src="
                            require(`@/assets/images/vehicles/${detail.vehicle.vehicleType.icon}/${detail.vehicle.vehicleType.icon}-orange.png`)
                          "
                          :alt="`mceasy-liveview-${detail.vehicle.vehicleType.icon}-icon`"
                        /><span>{{ $t('global.filter.idle') }}</span></label
                      >
                      <label
                        ><img
                          :src="
                            require(`@/assets/images/vehicles/${detail.vehicle.vehicleType.icon}/${detail.vehicle.vehicleType.icon}-red.png`)
                          "
                          :alt="`mceasy-liveview-${detail.vehicle.vehicleType.icon}-icon`"
                        /><span>{{ $t('global.filter.parking') }}</span></label
                      >
                      <label
                        ><img
                          :src="
                            require(`@/assets/images/vehicles/${detail.vehicle.vehicleType.icon}/${detail.vehicle.vehicleType.icon}-grey.png`)
                          "
                          :alt="`mceasy-liveview-${detail.vehicle.vehicleType.icon}-icon`"
                        /><span>{{ $t('global.filter.offline') }}</span></label
                      >
                    </div>
                  </li>
                </ul>
              </div>
            </b-popover>
          </span>
        </span>
      </div>
      <GmapMap
        id="map"
        ref="MapAddress"
        :center="{
          lat: parseFloat(detail.latitude),
          lng: parseFloat(detail.longitude),
        }"
        :zoom="14"
        class="mc-map"
      >
        <gmap-custom-marker
          :offsetY="25"
          :marker="{
            lat: detail.latitude ? parseFloat(detail.latitude) : '',
            lng: detail.longitude ? parseFloat(detail.longitude) : '',
          }"
        >
          <img
            :src="
              require(`@/assets/images/vehicles/${detail.vehicle.vehicleType.icon}/${detail.vehicle.vehicleType.icon}-dark-grey.png`)
            "
            :style="`transform: rotate(${parseInt(90)}deg);`"
            :alt="`mceasy-liveview-${detail.vehicle.vehicleType.icon}-icon`"
          />
        </gmap-custom-marker>
        <GmapInfoWindow
          :position="{
            lat: detail.latitude ? parseFloat(detail.latitude) : '',
            lng: detail.longitude ? parseFloat(detail.longitude) : '',
          }"
          :opened="true"
        >
          <div class="mc-modal-fleet mc-modal-fleet--notif">
            <div class="mc-modal-fleet__item">
              <!-- username  -->
              <h3 class="mc-modal-fleet__item-title">
                {{ detail.vehicle.licensePlate }} -
                {{ detail.driver ? detail.driver.fullname : $t('global.text.noDriver') }}
                <a @click="$router.go(-1)">
                  <i class="mc-fa icon-outline_close"></i>
                </a>
              </h3>
              <div>
                <div
                  class="mc-modal-fleet__item-status mc-modal-fleet__item-status--notif clearfix mb-3 mt-3"
                >
                  <h4 class="text-danger float-start w-50">
                    {{
                      $i18n.locale === 'id'
                        ? detail.alert.descriptionIdn
                        : detail.alert.descriptionEng
                    }}
                  </h4>
                  <div class="float-end w-50 text-end">
                    <b-button
                      :disabled="true"
                      v-b-modal.modal-call
                      :title="$t('notification.action.callDriver')"
                      class="float-end"
                      variant="outline-primary"
                    >
                      <i class="mc-fa icon-outline_phone"></i>
                      {{ $t('notification.action.callDriver') }}
                    </b-button>
                  </div>
                </div>
                <dl class="mc-modal-fleet__item-list clearfix">
                  <dt>{{ $t('global.time.time') }}</dt>
                  <dd>
                    {{ momentDateShortMonth(detail.createdOn) }} -
                    {{ momentTimeSeconds(detail.createdOn) }} WIB
                  </dd>
                  <dt>{{ $t('liveView.infoWindow.location') }}</dt>
                  <dd>{{ detail.address }}</dd>
                  <dt v-if="detail.alert.alertCode == '8' || detail.alert.alertCode == '18'">
                    {{
                      detail.alert.alertCode == '8'
                        ? $t('liveView.infoWindow.speed')
                        : $t('global.alert.temperature')
                    }}
                  </dt>
                  <dd v-if="detail.alert.alertCode == '8' || detail.alert.alertCode == '18'">
                    {{ detail.formattedAlertData }}
                    {{
                      detail.alert.alertCode == '8' ? 'Km/' + $t('global.time.hours') : '&#176; C'
                    }}
                  </dd>
                  <dt v-if="detail.alert.alertCode == '8'">{{ $t('global.object.limit') }}</dt>
                  <dd v-if="detail.alert.alertCode == '8'">
                    {{ detail.alertTrigger }} Km/{{ $t('global.time.hours') }}
                  </dd>
                </dl>
              </div>
            </div>
            <div class="mc-modal-fleet__item" v-if="phaseOneShow">
              <b-form-group
                :label="$t('notification.text.comment')"
                label-for="text-comment"
                class="mb-3"
              >
                <b-form-textarea
                  :disabled="true"
                  id="text-comment"
                  size="lg"
                  :placeholder="$t('notification.text.writeComment')"
                ></b-form-textarea>
              </b-form-group>
              <div class="mc-modal-fleet__item-status--notif-list">
                <div class="mc-modal-fleet__item-status--notif-list-item">
                  <h4>
                    Admin 1 <span>{{ $t('global.time.today') }}</span>
                  </h4>
                  <p>
                    Lorem ipsum dolor sit amet ipsum dolor sit amet ipsum dolor sit amet ipsum dolor
                    sit amet ipsum dolor sit amet
                  </p>
                  <i class="mc-fa icon-outline_more-vertical"></i>
                </div>
                <div class="mc-modal-fleet__item-status--notif-list-item">
                  <h4>
                    Admin 1 <span>{{ $t('global.time.today') }}</span>
                  </h4>
                  <p>
                    Lorem ipsum dolor sit amet ipsum dolor sit amet ipsum dolor sit amet ipsum dolor
                    sit amet ipsum dolor sit amet
                  </p>
                  <i class="mc-fa icon-outline_more-vertical"></i>
                </div>
              </div>
            </div>
            <h4
              class="mc-sidebar-liveview__list-notif-more d-block btn btn-outline-primary mt-3"
              :class="showHideDetailNotif ? 'mc-notif-close' : 'mc-notif-open'"
              v-on:click="showHideDetailNotif = !showHideDetailNotif"
              v-if="phaseOneShow"
            >
              <span class="mc-notif-open-text"
                ><i class="mc-fa icon-outline_arrow-ios-down"></i>
                {{ $t('global.action.seeMore') }}</span
              >
              <span class="mc-notif-close-text"
                ><i class="mc-fa icon-outline_arrow-ios-up"></i>
                {{ $t('global.action.close') }}</span
              >
            </h4>
          </div>
        </GmapInfoWindow>
      </GmapMap>
    </div>
    <b-modal
      class="mc-modal"
      id="modal-call"
      ref="modal-call"
      :title="$t('nofitication.action.callDriver')"
      header-bg-variant="primary"
      header-close-variant="light"
      :ok-title="$t('global.action.register')"
      :cancel-title="$t('global.action.close')"
      cancel-variant="outline-primary"
      size="md"
      centered
    >
      <b-row align-h="center">
        <b-col>
          <b-form-group
            id="fieldset-1"
            :label="$t('notification.text.enterNumber')"
            label-for="noHP"
          >
            <b-input-group prepend="+62">
              <b-form-input
                id="noHP"
                trim
                :placeholder="`${this.$t('global.action.enterNumber')}+...`"
              ></b-form-input>
            </b-input-group>
          </b-form-group>
        </b-col>
      </b-row>
    </b-modal>
  </Layout>
</template>
